import React, { useState, useEffect } from "react";
import { Box, Typography, Stack } from "@mui/material";

import card_image_1 from "../../../../../assets/card_image_1.jpg";
import card_image_2 from "../../../../../assets/card_image_2.jpg";
import card_image_3 from "../../../../../assets/card_image_3.jpg";
import card_image_4 from "../../../../../assets/card_image_4.jpg";
import card_image_5 from "../../../../../assets/card_image_5.jpg";
import card_image_6 from "../../../../../assets/card_image_6.jpg";

const fallbackImages = [
  card_image_1,
  card_image_2,
  card_image_3,
  card_image_4,
  card_image_5,
  card_image_6,
];

interface GalleryProps {
  images?: any[]; // intentionally loose since input may not be string[]
}

export const Gallery: React.FC<GalleryProps> = ({ images = [] }) => {
  // 🧠 Normalize image input — string URLs only
  const normalizedUrls: string[] = images.map((img) =>
    typeof img === "string" ? img : img?.url
  );

  const galleryImages = normalizedUrls.length > 0 ? normalizedUrls : "";

  const [selectedImage, setSelectedImage] = useState<string | null>(
    galleryImages[0]
  );

  useEffect(() => {
    console.log("🖼️ Received Gallery Images:", images);
    setSelectedImage(galleryImages[0]);
  }, [images]);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ font: "var(--h6)" }} mb={2}>
        Gallery
      </Typography>

      {normalizedUrls.length === 0 && (
        <Typography variant="body2" color="text.secondary" mb={2}>
          No gallery images found for this card.
        </Typography>
      )}

      {/* Selected Image */}
      {selectedImage && (
        <Box
          component="img"
          src={selectedImage}
          alt="Selected Preview"
          sx={{
            width: "100%",
            height: { xs: 280, md: 380 },
            objectFit: "cover",
            borderRadius: 3,
            mb: 2,
            boxShadow: "0px 3px 16px rgba(0,0,0,0.12)",
          }}
        />
      )}

      {/* Thumbnail Images */}
      <Stack direction="row" spacing={2} flexWrap="wrap">
        {galleryImages &&
          galleryImages.map((img, idx) => (
            <Box
              key={idx}
              component="img"
              src={img}
              alt={`Gallery ${idx}`}
              onClick={() => setSelectedImage(img)}
              sx={{
                width: 70,
                height: 70,
                borderRadius: 2,
                objectFit: "cover",
                cursor: "pointer",
                border:
                  img === selectedImage
                    ? "3px solid #6366F1"
                    : "2px solid transparent",
                transition: "all 0.2s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                },
              }}
            />
          ))}
      </Stack>
    </Box>
  );
};
